// 진행 중(in-flight) 결제의 localStorage 영속.
//
// 카드/간편 모두 결제창(외부 PG · 외부 브라우저)으로 이탈하기 전에 { examId, orderId } 를 저장한다.
// - 카드: 현재 WebView 가 언로드(SPA 파괴)되므로, 302 복귀한 콜드스타트 결과페이지가
//   URL 쿼리(우선) 또는 이 값으로 examId/orderId 를 복원해 폴링한다.
// - 간편(easypay, #282): onEasyPayReturn({ orderId }) 콜백엔 examId 가 없고,
//   AOS 콜드 폴백 /payment/return?orderId= 에도 orderId 만 있으므로, orderId 로 이 슬롯을 매칭해 examId 를 얻는다.
//
// 단일 슬롯: 한 번에 하나의 결제만 진행한다(신청 플로우가 순차라 동시 in-flight 없음).
// sessionStorage 가 아니라 localStorage — WebView eviction · 프로세스 사망 · 콜드스타트에도 살아남아야 한다.

const KEY = "maketrend.exam.payment.inflight";

export type InflightPayment = {
  examId: number;
  orderId: string;
  /** epoch ms — 지나치게 오래된 잔재 판별용(선택). */
  startedAt: number;
};

/** 결제창 이탈 직전 저장. 기존 슬롯은 덮어쓴다(단일 슬롯). */
export const saveInflightPayment = (examId: number, orderId: string): void => {
  try {
    const value: InflightPayment = { examId, orderId, startedAt: Date.now() };
    localStorage.setItem(KEY, JSON.stringify(value));
  } catch {
    // localStorage 불가(사파리 프라이빗 등) — 저장 실패는 콜드 복원만 약화, 정상 복귀 흐름은 유지.
  }
};

/** 저장된 in-flight 결제. 없거나 손상 시 null. */
export const readInflightPayment = (): InflightPayment | null => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<InflightPayment> | null;
    if (
      !parsed ||
      typeof parsed.examId !== "number" ||
      typeof parsed.orderId !== "string" ||
      parsed.orderId.length === 0
    ) {
      return null;
    }
    return {
      examId: parsed.examId,
      orderId: parsed.orderId,
      startedAt: typeof parsed.startedAt === "number" ? parsed.startedAt : 0,
    };
  } catch {
    return null;
  }
};

/** 종단(성공/실패/취소 확정) 시 정리 — 유령 재폴링 방지. */
export const clearInflightPayment = (): void => {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // noop — 삭제 실패해도 다음 저장이 덮어쓴다.
  }
};
